// extracted by mini-css-extract-plugin
export default {"row":"f3Ddv35FIaxmuAo42EBP","wrapper":"FdQ1PUn7KBzX4PpBFhP1"};